// src/images.js
const images = {
  mercadoLibre: '/images/mercado_libre.svg',
  tiendaNube: '/images/tienda_nube.svg',
  meliIcon: '/images/meli_icon.svg',
  tnIcon: '/images/tn_icon.svg',
};

export default images;